// extracted by mini-css-extract-plugin
export default {"header":"ESIMTable_header__hVGkh","rows":"ESIMTable_rows__G2ze+","row":"ESIMTable_row__p7kqn"};